<template>
  <div v-loading="loading" class="h-100">
    <el-card shadow="never" class="process-select">
      <div slot="header" class="clearfix">
        <span>进度模拟</span>
        <div style="float: right; padding: 3px 0">
          <el-select v-model="selectionModel" size="small" @change="changeProcessModel">
            <el-option
              v-for="item in processModelList"
              :key="item.id"
              :label="item.name + `[${item.fileName}]`"
              :value="JSON.stringify(item)"
            ></el-option>
          </el-select>
          <el-tooltip placement="top" content="隐藏" :open-delay="1000">
            <span
              class="iconfont control-icon icon-left fz-16"
              style="margin: 0 10px;"
              @click="showProcessMode"
            ></span>
          </el-tooltip>
          <el-tooltip placement="top" content="关闭" :open-delay="1000">
            <span class="iconfont control-icon icon-close fz-16" @click="changeProcessMode"></span>
          </el-tooltip>
        </div>
      </div>
      <div>
        <el-row type="flex" align="middle" class="search-item">
          <el-col :span="7">
            <span>计划名称</span>
          </el-col>
          <el-col :span="16">
            <el-select
              size="small"
              class="w-100 topSelect"
              v-model="progressId"
              @change="changePlan"
              placeholder="请选择计划"
            >
              <el-option
                v-for="item in allPlanArr"
                :key="item.id"
                :label="item.name"
                :value="JSON.stringify(item)"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="search-item">
          <el-col :span="7">
            <span>开始日期</span>
          </el-col>
          <el-col :span="16">
            <el-date-picker
              size="small"
              :disabled="!canSelect"
              class="w-100"
              v-model="filter.dateRange[0]"
              :picker-options="datePickOption"
              type="date"
              placeholder="开始日期"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row class="search-item">
          <el-col :span="7">
            <span>结束日期</span>
          </el-col>
          <el-col :span="16">
            <el-date-picker
              class="w-100"
              size="small"
              :disabled="!canSelect"
              v-model="filter.dateRange[1]"
              :picker-options="datePickOption"
              type="date"
              placeholder="结束日期"
              @change="handleFilter"
            ></el-date-picker>
          </el-col>
        </el-row>
        <el-row class="search-item">
          <el-col :span="7">
            <span>查看日期</span>
          </el-col>
          <el-col :span="16">
            <el-date-picker
              size="small"
              :disabled="!canSelect"
              v-model="filter.checkDate"
              type="date"
              placeholder="查看日期"
              :picker-options="datePickOption"
              @change="handleCheck"
            ></el-date-picker>
          </el-col>
        </el-row>
      </div>
    </el-card>
    <el-card shadow="never" class="info-panel" style="height: calc(70% - 5px)">
      <div class="h-100">
        <div v-if="showProcess" class="h-10">
          <el-row type="flex" class="modal-player">
            <el-col class="tl">
              <el-button-group>
                <el-button type="primary" :loading="btnLoading" size="mini" @click="minusSpeed">
                  <i class="iconfont icon-bg-backward"></i>
                </el-button>
                <el-button type="primary" size="mini" @click="btnPlay" :loading="btnPlayLoading">
                  <i class="iconfont icon-pause" v-if="playing"></i>
                  <i class="iconfont icon-fa-play" v-else></i>
                </el-button>
                <el-button type="primary" :loading="btnLoading" size="mini" @click="reset">
                  <i class="iconfont icon-fa-stop"></i>
                </el-button>
                <el-button type="primary" :loading="btnLoading" size="mini" @click="addSpeed">
                  <i class="iconfont icon-bg-forward"></i>
                </el-button>
              </el-button-group>
              <span class="p-l-10">{{ speedModes[currentSpeed] }}X</span>
            </el-col>
          </el-row>
          <el-row class="tl">
            <el-slider
              :disabled="btnLoading"
              @change="sliderChanged"
              :show-tooltip="false"
              :min="1"
              :max="sliderMaxLenngth"
              v-model="slider1"
            ></el-slider>
          </el-row>
        </div>
        <div
          v-if="(currentModel && currentModel.currentDate) || sliderLoading"
          class="model_data h-90"
          v-loading="sliderLoading"
        >
          <div class="h-40">
            <h2 class="fz-24">
              {{
                currentModel && currentModel.currentDate
                  ? moment(currentModel.currentDate).format('YYYY/MM/DD')
                  : ''
              }}
            </h2>
            <div v-for="(item, index) in highLightData" :key="index">
              <div>
                <i
                  class="iconfont icon-circle fz-12"
                  :style="{
                    color: item.color,
                  }"
                ></i>
                <span class="fz-12">{{ item.name }} :</span>
                <span class="fz-12">
                  <template v-if="index === 0">{{
                    !_.isEmpty(currentShowNum) ? currentShowNum.workAsPlan : 0
                  }}</template>
                  <template v-if="index === 1">{{
                    !_.isEmpty(currentShowNum) ? currentShowNum.workDelayPlan : 0
                  }}</template>
                  <template v-if="index === 2">
                    {{ !_.isEmpty(currentShowNum) ? currentShowNum.workDelayDone : 0 }}
                  </template>
                  <template v-if="index === 3">
                    {{ !_.isEmpty(currentShowNum) ? currentShowNum.delayPlanStart : 0 }}
                  </template>
                  <template v-if="index === 4">
                    {{ !_.isEmpty(currentShowNum) ? currentShowNum.noWork : 0 }}
                  </template>
                  <template v-if="index === 5">
                    {{ !_.isEmpty(currentShowNum) ? currentShowNum.alreadyDone : 0 }}
                  </template>

                  <template v-if="index === 6">
                    {{ !_.isEmpty(currentShowNum) ? currentShowNum.notInRange : 0 }}
                  </template>
                  <span class="fz-12">个</span>
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="
              currentModel &&
                currentModel.currentImplementTree &&
                currentModel.currentImplementTree.length &&
                !showTaskDetail
            "
            class="h-60 m-t-20"
          >
            <h3 class="m-b-10 today-task-h3">今日任务</h3>
            <div class="today-task-box">
              <div v-for="(i, index) in currentModel.currentImplementTree" :key="index">
                <div @click="handleClickTask(i)" class="fz-14 has-text-info today-task">
                  {{ i.name }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="showTaskDetail" class="h-60 m-t-20">
            <span>任务详情</span>
            <span class="iconfont icon-close close-task" @click="showTaskDetail = false"></span>
            <el-tabs v-model="activeRelatedName" class="h-90" @tab-click="handleRelatedTask">
              <el-tab-pane name="baseInfo" label="基本信息" class="h-100">
                <div class="process-info">
                  <div class="process-info__list b-none d-flex flex-align-center">
                    <p class="info-left">任务代码</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.code }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center b-none">
                    <p class="info-left">任务名称</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.name }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center b-none">
                    <p class="info-left">计划开始时间</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.planStartDate }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center b-none">
                    <p class="info-left">计划结束时间</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.planFinishDate }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center b-none">
                    <p class="info-left">实际开始时间</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.actualStartDate }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center">
                    <p class="info-left">实际结束时间</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.actualFinishDate }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center">
                    <p class="info-left">工期</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.actualDuration }}</p>
                  </div>
                  <div class="process-info__list d-flex flex-align-center">
                    <p class="info-left">完成百分比</p>
                    <p class="info-detail p-l-10 p-r-10 flex-1">{{ taskItem.progress }}</p>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane
                :label="item.label"
                :name="item.name"
                v-for="item in taskTab"
                :key="item.name"
                class="h-100"
              >
                <div style="overflow-y:scroll" class="h-100" v-if="isShow">
                  <div class="p-b-10">
                    <el-tooltip
                      content="上传图片"
                      :open-delay="1000"
                      effect="light"
                      v-if="item.name === 'taskPhotos'"
                    >
                      <el-button
                        type="success"
                        class="m-l-5"
                        size="mini"
                        icon="iconfont icon-upload"
                        @click="uploadBtn()"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="上传文件" :open-delay="1000" effect="light" v-else>
                      <el-button
                        type="success"
                        class="m-l-5"
                        size="mini"
                        icon="iconfont icon-upload"
                        @click="uploadBtn()"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="批量删除" :open-delay="1000" effect="light">
                      <el-button
                        type="danger"
                        class="m-l-5"
                        size="mini"
                        icon="iconfont icon-close"
                        @click="batchDeleteRelated()"
                      ></el-button>
                    </el-tooltip>
                  </div>
                  <div style="height: calc(100% - 50px)">
                    <el-table
                      :data="taskRelatedList"
                      height="90%"
                      v-loading="taskRelatedLoading"
                      border
                      :highlight-current-row="true"
                      @selection-change="selectionChange"
                      stripe
                    >
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column prop="fileName" label="文件名">
                        <template slot-scope="scope">
                          <p class="cur_pointer fc-primary" @click="showRelated(scope.row)">
                            {{ scope.row.fileName }}
                          </p>
                        </template>
                      </el-table-column>
                      <el-table-column prop="createdTime" label="上传时间" width="200">
                        <template slot-scope="scope">
                          <span>
                            {{
                              scope.row.createdTime
                                ? moment(scope.row.createdTime).format('lll')
                                : '暂无日期'
                            }}
                          </span>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                          <el-tooltip content="下载" :open-delay="1000" effect="light">
                            <el-button
                              type="success"
                              size="mini"
                              icon="iconfont icon-download"
                              @click="downloadRelated(scope.row)"
                            ></el-button>
                          </el-tooltip>
                          <el-tooltip content="删除" :open-delay="1000" effect="light">
                            <el-button
                              type="danger"
                              class="m-l-5"
                              size="mini"
                              icon="iconfont icon-close"
                              @click="deleteRelated(scope.row)"
                            ></el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 已绑定构件 begin -->
              <el-tab-pane label="相关构件" name="taskTags" class="h-100">
                <div class="h-100">
                  <div class="p-b-5">
                    <el-tooltip content="绑定" :open-delay="1000" effect="light">
                      <el-button
                        type="success"
                        icon="iconfont icon-link"
                        class="m-l-5"
                        size="mini"
                        @click="openBindDialog"
                      ></el-button>
                    </el-tooltip>
                    <el-tooltip content="解绑" :open-delay="1000" effect="light">
                      <el-button
                        type="danger"
                        icon="iconfont icon-unlink"
                        size="mini"
                        class="m-l-5"
                        @click="unlinkTagList(unBindTagList)"
                      ></el-button>
                    </el-tooltip>
                  </div>
                  <div style="height: calc(100% - 50px)">
                    <el-table
                      :data="taskTagList"
                      border
                      highlight-current-row
                      stripe
                      height="100%"
                      @selection-change="selectedBindTag"
                    >
                      <el-table-column
                        type="selection"
                        width="55"
                        v-if="tableHeader.length"
                      ></el-table-column>
                      <template v-for="(item, index) in tableHeader">
                        <el-table-column
                          :prop="item.value"
                          :label="item.label"
                          :key="index"
                        ></el-table-column>
                      </template>
                      <el-table-column label="操作" v-if="tableHeader.length">
                        <template slot-scope="scope">
                          <el-tooltip content="解除绑定" effect="light" :open-delay="1000">
                            <el-button
                              type="danger"
                              size="mini"
                              icon="iconfont icon-unlink"
                              @click.stop="unlinkTagList([scope.row])"
                            ></el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 已绑定构件 end -->

              <!-- 任务相关图纸 start -->
              <el-tab-pane label="相关图纸" name="taskPaper" class="h-100">
                <div class="h-100">
                  <div class="p-b-10">
                    <el-tooltip content="批量删除" :open-delay="1000" effect="light">
                      <el-button
                        type="danger"
                        class="m-l-5"
                        size="mini"
                        icon="iconfont icon-close"
                      ></el-button>
                    </el-tooltip>
                  </div>
                  <div style="height: calc(100% - 50px)">
                    <el-table
                      :data="planRelatedPaperList"
                      height="100%"
                      border
                      highlight-current-row
                      stripe
                    >
                      <el-table-column type="selection" width="55"></el-table-column>
                      <el-table-column prop="name" label="文件名"></el-table-column>
                      <el-table-column label="操作" width="100">
                        <template>
                          <el-tooltip content="删除" :open-delay="1000" effect="light">
                            <el-button
                              type="danger"
                              class="m-l-5"
                              size="mini"
                              icon="iconfont icon-close"
                            ></el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-tab-pane>
              <!-- 任务相关图纸 end -->
              <!-- 任务相关设备 start -->
              <el-tab-pane label="相关设备" name="taskTools" class="h-100">
                <div class="h-100">任务相关设备</div>
              </el-tab-pane>
              <!-- 任务相关设备 end -->
            </el-tabs>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="uploadRelatedVisible"
      :before-close="closeDialog"
    >
      <uploadFilesDrag
        :multiple="false"
        :accept="accept"
        @uploadFinish="uploadFinish"
        ref="UploadFilesDrag"
      ></uploadFilesDrag>
    </el-dialog>
    <el-dialog
      :visible.sync="selectionTagDialog"
      :close-on-click-modal="false"
      @close="closeSelectionTagDialog"
      title="选中构件列表信息"
    >
      <el-table :data="handleClickTagData" border height="380px" v-loading="modelTreeLoading">
        <template>
          <el-table-column
            :prop="item.value"
            :label="item.label"
            :key="index"
            v-for="(item, index) in handleClickTagDataHeader"
          ></el-table-column>
        </template>
        <el-table-column label="操作" v-if="tagCollection.length">
          <template slot-scope="scope">
            <el-tooltip content="删除" :open-delay="1000">
              <el-button
                size="mini"
                icon="iconfont icon-delete"
                type="danger"
                @click="deleteBindTag(scope.row, scope.$index)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" v-show="tagCollection.length">
        <el-button @click="closeSelectionTagDialog">取消</el-button>
        <el-button type="primary" @click="bindTagList" :loading="subLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import encodeUrl from 'encodeurl'
import ConfirmAuth from '@/assets/js/confirmAuth'
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import ApiMixinDocument from '@/assets/js/api/documents'
import constructionManage from '@/services/constructionManage'
import planDetail from '@/services/planDetail'
import ApiMixinProceeding from '@/assets/js/api/proceeding'
import uploadFilesDrag from '@/components/uploadFilesDrag'

import DocumentService from '@/services/DocumentService'

export default {
  components: {
    uploadFilesDrag,
  },
  props: ['modelDocumentId'],
  async mounted() {
    this.reset()
  },
  watch: {
    async planItemEdit() {
      this.plans = await this.init()
      this.basePlans = _.cloneDeep(this.plans)
      console.log('this.$store.getters.planItemClicked.id', this.$store.getters.planItemClicked.id)
      this.getRelationFiles(this.$store.getters.planItemClicked.id)
    },
    async planItemClicked() {
      this.once = true
      this.connectionType = ''
      console.log(
        '点击触发这里，自己看看看看this.$store.getters.planItemClicked',
        this.$store.getters.planItemClicked
      )
      if (this.$store.getters.planItemClicked) {
        if (this.oldModelTreeValue) {
          this.oldModelTreeValue = []
        }
        this.isShow = true
        this.getRelationFiles(this.$store.getters.planItemClicked.id)
        this.tagCollection = []
        this.handleClickTagDataHeader = []
        this.handleClickTagData = []
        await this.getRowBindTag(this.$store.getters.planItemClicked.id, false)
        // const arr = (await this.getIsAllBindTag()).data
        const codeArr = _.map(this.allTagData, (item) => {
          return item.Code
        })
        console.log('当前关联位号', this.taskTagList)
        const codeArr2 = _.map(this.taskTagList, (val) => {
          return val.Code
        })
        console.log('任务关联构件', codeArr, codeArr2)
        const paperQuery = {
          activityId: this.$store.getters.planItemClicked.id,
        }
        console.log(paperQuery)
        const paperRes = await planDetail.askPaperInfo(paperQuery)
        if (paperRes) {
          const obj = []
          _.forEach(paperRes.data[0].volumn.split(';'), (value, index) => {
            const pushObj = {
              name: value,
            }
            obj.push(pushObj)
          })
          console.log(obj)
          this.planRelatedPaperList = obj
        }
      }
    },
    async modelRes() {
      this.model = _.orderBy(this.modelRes, ['currentDate'], ['asc'])
      // 筛选只含有List的数据
      this.modelList = _.map(this.model, (el) => {
        el = _.pickBy(el, (v, k) => {
          return _.endsWith(k, 'List')
        })
        return _.mapKeys(el, (v, k) => {
          return k.replace('List', '')
        })
      })
    },
    currentTiming() {
      const toTodayData = _.slice(this.modelList, 0, this.currentTiming)
      if (this.currentTiming >= this.model.length) {
        this.currentModel = _.last(this.model)
        this.slider1 = this.model.length
        this.playing = false
        clearInterval(this.timer)
      }
      const currentDate = moment(this.currentModel.currentDate).format('YYYY-MM-DD')
      this.currentShowNum = _.find(this.showNum, { dateTime: currentDate })
      this.$emit('changeModelColor', {
        data: toTodayData,
        day: this.currentTiming,
      })
    },
    async loaded() {
      if (this.loaded && this.btnPlayLoading) {
        const modelInfo = await PlayerUtils.call(
          window.player.Native.Model.getInfo,
          this.selectionModel.md5
        )
        window.player.Native.ModelTree.setItemColor(modelInfo.treeItem, 0xffffff80)
        this.btnPlay()
      }
    },
  },
  data() {
    return {
      bufferArray: [],
      showProcess: false,
      oldModelTreeValue: [],
      subLoading: false,
      handleClickTagData: [],
      handleClickTagDataHeader: [],
      accept: '.png, .jpg, .jpeg, .JPG, .JPEG, .PNG',
      uploadRelatedVisible: false,
      modelTreeLoading: false,
      tagCollection: [],
      selectionTagDialog: false,
      planRelatedPaperList: [
        {
          name: 'asdasdasd',
        },
      ], // 相关任务图纸表格数据
      tableHeader: [],
      taskTagList: [],
      unBindTagList: [],
      relatedFilesSelectedId: [],
      taskRelatedLoading: false,
      taskRelatedList: [],
      isShow: true,
      taskTab: [
        {
          label: '相关照片',
          name: 'taskPhotos',
        },
        {
          label: '相关文件',
          name: 'taskFiles',
        },
      ],
      tabName: 'baseInfo',
      loading: false,
      sliderLoading: false, // 滑动进度条
      sliderLoadingTimer: null,
      showNum: [], // 显示数据
      cancelFn: [],
      currentTiming: 0,
      slider1: 0,
      model: [],
      currentSpeed: 0,
      speedModes: [1, 3, 7],
      btnLoading: false,
      btnPlayLoading: false,
      sceneReady: false,
      playing: false,
      taskItem: {},
      taskInfo: [],
      basePlans: [],
      plans: [],
      filter: {
        dateRange: [],
        checkDate: '',
      },
      currentShowNum: {},
      highLightColor: null,
      highLightData: [],
      currentModel: {
        advanceList: [],
        milestonLagList: [],
        otherLagList: [],
      },
      progressId: '',
      allPlanArr: [], // 所有的计划的list
      activeRelatedName: 'baseInfo',
      processModelList: [],
      selectionModel: '',
      showTaskDetail: false,
      modelList: [],
      progressCodeList: [],
      progressCodeByItem: {},
      canSelect: false,
      loaded: false,
      planStartDate: '', // 计划开始时间
      planFinishDate: '', // 计划结束时间
      planModelInfo: [],
      allModelRes: [], //
      allModel: [], // 所有model数据
      allModelList: [], // 所有数据
      allShowNum: [],
      handleCheckLoadingTimer: null, // 查看日期定时器
    }
  },
  mixins: [
    ApiMixinProceeding,
    FnMixins,
    ApiMixinCable,
    ApiMixinDictionaryManagement,
    ApiMixinDocument,
  ],
  async created() {
    this.highLightColor = JSON.parse(this.colorCollection)
    await this.getProcessModel()
    if (this.processModelList.length) {
      if (this.modelDocumentId) {
        const processModel = _.find(this.processModelList, ['id', this.modelDocumentId])
        console.log(processModel)
        this.selectionModel = !_.isNil(processModel)
          ? JSON.stringify(processModel)
          : JSON.stringify(this.processModelList[0])
        this.reset()
      } else {
        this.selectionModel = JSON.stringify(this.processModelList[0])
        this.changeProcessModel(this.selectionModel)
      }
    }
    // 拿到所有的计划
    this.searchProcessPlan()
    this.highLightData = [
      {
        name: '正在施工（按计划施工）',
        color: this.highLightColor.workInProgress ? this.highLightColor.workInProgress : '#67C23A',
      },
      {
        name: '正在施工（落后计划开始）',
        color: this.highLightColor.delayedStart ? this.highLightColor.delayedStart : '#9A32CD',
      },
      {
        name: '正在施工（落后计划结束）',
        color: this.highLightColor.delayedUnfinished
          ? this.highLightColor.delayedUnfinished
          : '#FFFF00',
      },
      {
        name: '未施工（落后计划开始）',
        color: this.highLightColor.delayedConstruction
          ? this.highLightColor.delayedConstruction
          : '#F56C6C',
      },
      {
        name: '未施工（按计划未施工）',
        color: this.highLightColor.norMalNonConstruction
          ? this.highLightColor.norMalNonConstruction
          : '#409EFF',
      },
      {
        name: '已完成施工',
        color: this.highLightColor.constructed ? this.highLightColor.constructed : '#1890ff',
      },
      {
        name: '不在施工进度时间范围内',
        color: this.highLightColor.notInDateRange ? this.highLightColor.notInDateRange : '#ebeef5',
      },
    ]
  },
  computed: {
    // 时间允许选择范围
    datePickOption() {
      const that = this
      return {
        disabledDate: (time) => {
          if (this.planStartDate && this.planFinishDate) {
            return (
              time.getTime() < moment(that.planStartDate).valueOf() ||
              time.getTime() > moment(that.planFinishDate).valueOf()
            )
          }
          return true
        },
      }
    },
    // 进度条最大长度
    sliderMaxLenngth() {
      if (
        this.filter.dateRange[0] &&
        this.filter.dateRange[1] &&
        moment(this.filter.dateRange[0]).isBefore(this.filter.dateRange[1])
      ) {
        return moment(this.filter.dateRange[1]).diff(moment(this.filter.dateRange[0]), 'day') + 1
      }
      return 1
    },
    planItemEdit() {
      return this.$store.getters.planItemEdit
    },
    planItemClicked() {
      return this.$store.getters.planItemClicked
    },
    cardHeight() {
      return `${window.innerHeight - 140}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    showVersion() {
      const systemParams = this.$store.getters.systemParams || []
      const version = _.find(systemParams, { parameterCode: '5D_VERSION' })
      return version ? version.parameterValue : '1'
    },
    colorCollection() {
      const systemParams = this.$store.getters.systemParams || []
      const color = _.find(systemParams, { parameterCode: 'PLAYER_COLOR_COLLECTION' })
      console.warn(color)
      return color ? color.parameterValue : null
    },
    // modelStandby() {
    //   return this.model.length
    // },
  },
  methods: {
    // 获取所有已绑定的tag
    async getIsAllBindTag() {
      const arr = await this.getBindTagList(JSON.parse(this.progressId).id, true)
      const result = this.transferData(arr, true)
      return result
    },
    // 切换计划
    async changePlan(val) {
      this.allModelRes = []
      this.allModel = []
      this.allModelList = []
      this.allShowNum = []
      console.log(JSON.parse(val))
      this.showProcess = true
      this.sliderLoading = true
      this.$set(this.filter.dateRange, 0, JSON.parse(val).planStartDate)
      this.$set(this.filter.dateRange, 1, JSON.parse(val).planFinishDate)
      this.planStartDate = JSON.parse(val).planStartDate
      this.planFinishDate = JSON.parse(val).planFinishDate
      this.handleFilter()
    },
    // 操作返回的数据
    transferData(data, isTable) {
      const arr = []
      const headerData = []
      if (data.length) {
        data.forEach((item, index) => {
          arr[index] = {}
          item.forEach((val) => {
            if (isTable && index === 0 && val.code !== 'id') {
              headerData.push({ label: val.name, value: val.code })
            }
            this.$set(arr[index], val.code, val.value)
          })
        })
        // console.log('headerData', headerData)
        // console.log('data', arr)
      }
      return { data: arr, header: headerData }
    },
    // 获取已绑定位号数据
    async getBindTagList(id, type) {
      const res = await this.apiPlans({
        method: this.showVersion === '1' ? 'selectionTag' : 'selectionTagHy',
        params: {
          activityid: id,
          is_recursive_children: type,
        },
      })
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 获取单行已绑定的位号
    async getRowBindTag(id, type) {
      const arr = await this.getBindTagList(id, type)
      const result = this.transferData(arr, true)
      this.taskTagList = result.data
      this.tableHeader = result.header
      console.log('this.tableHeader', this.tableHeader)
    },
    // 获取相关内容
    async getRelationFiles(data) {
      this.taskRelatedLoading = true
      this.planRelatedLoading = true
      const relatedRes = await this.apiRelatedFiles({
        method: 'relatedList',
        params: {
          where: {
            activityId: data,
            fileType: ['ImageConn', 'DocumentConn'],
          },
        },
      })
      console.log('当前tab名称', this.tabName, this.$store.getters.planItemClicked.id)
      if (relatedRes.success && relatedRes.data) {
        this.taskTotalData = relatedRes.data
        switch (this.tabName) {
          case 'taskPhotos':
            this.taskRelatedList = this.taskTotalData.imageList
            break
          case 'taskFiles':
            this.taskRelatedList = this.taskTotalData.documentFileList
            break
          default:
        }
      } else {
        this.taskTotalData = null
        this.planTotalData = null
      }
      this.taskRelatedLoading = false
    },
    // 关闭tag查看模态框
    closeSelectionTagDialog() {
      this.selectionTagDialog = false
    },
    // 绑定构件
    async bindTagList() {
      this.subLoading = true
      const tagIds = _.map(this.handleClickTagData, (item) => {
        return item.id
      })
      const res = await this.apiPlans({
        method: 'bindOrUnbind',
        params: {
          documentId: this.documentId,
          activityId: this.planItemClicked.id || this.activityId,
          type: 0,
          tagIds,
        },
      })
      this.subLoading = false
      if (res && res.code === 0) {
        this.$store.dispatch('planItemEdit', _.random(100000, 999999))
        this.handleClickTagData = []
        this.handleClickTagDataHeader = []
        this.tagCollection = []
        await this.getRowBindTag(this.planItemClicked.id, false)
        this.allTagData = (await this.getIsAllBindTag()).data
        this.selectionTagDialog = false
        this.$message.success('保存成功')
      }
    },
    // 上传成功后
    async uploadFinish(data) {
      console.log(data)
      console.log('this.$route', this.$route)
      const md5 = _.map(data, (item) => {
        return item.md5
      })
      const fileName = _.map(data, (item) => {
        return item.fileName
      })
      const createdUser = await localforage.getItem('userInfo')
      const params = {
        md5: md5.join(','),
        siteId: this.currentProject.id,
        fileName: fileName.join(','),
        createdUser: createdUser.userName,
        progressId: JSON.parse(this.progressId).id,
        // topactivityId: this.$route.params.activityId,
      }
      if (this.tabName === 'taskPhotos' || this.tabName === 'taskFiles') {
        _.assign(params, {
          activityId: this.$store.getters.planItemClicked.id,
          type: this.tabName === 'taskPhotos' ? 0 : 1,
          taskType: 0,
        })
      } else {
        _.assign(params, {
          // activityId: this.$route.params.progressId,
          activityId: this.$store.getters.planItemClicked.id,
          type: this.tabName === 'planPhotos' ? 0 : 1,
          taskType: 1,
        })
      }
      const res = await this.apiRelatedFiles({
        method: 'saveRelatedFile',
        params,
      })
      if (res.success) {
        switch (this.tabName) {
          case 'taskPhotos':
            this.getRelationFiles(this.$store.getters.planItemClicked.id)
            break
          case 'taskFiles':
            this.getRelationFiles(this.$store.getters.planItemClicked.id)
            break
          //  case 'planPhotos':
          //    this.getRelationFiles(this.$route.params.progressId)
          //    break
          //  case 'planFiles':
          //    this.getRelationFiles(this.$route.params.progressId)
          //    break
          default:
        }
        this.closeDialog()
      }
      this.uploadRelatedVisible = false
    },
    closeDialog() {
      console.log('ggggggggg')
      this.uploadRelatedVisible = false
      this.$refs.UploadFilesDrag.deleteAll()
    },
    unlinkTagList(data) {
      if (data.length) {
        const tagIds = _.map(data, (item) => {
          return item.id
        })
        const tagCode = _.map(data, (item) => {
          return item.Code
        })
        this.$confirm('是否确定要解绑选择的任务?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const bindRes = await this.apiPlans({
            method: 'bindOrUnbind',
            params: {
              documentId: this.documentId,
              activityId: this.planItemClicked.id || this.activityId,
              type: 1,
              tagIds,
            },
          })
          if (bindRes && bindRes.code === 0) {
            this.$store.dispatch('planItemEdit', _.random(100000, 999999))
            this.handleClickTagData = []
            this.handleClickTagDataHeader = []
            this.tagCollection = []
            this.unBindTagList = []
            await this.getRowBindTag(this.planItemClicked.id, false)
            this.allTagData = (await this.getIsAllBindTag()).data
            this.$message.success('解绑成功')
          }
        })
      } else {
        this.$message.warning('请勾选位号！')
      }
    },
    selectedBindTag(selection) {
      console.log(selection)
      this.unBindTagList = selection
    },
    // 获取已绑定的数据
    async openBindDialog() {
      console.log('进入了openBindDialog')
      console.log(this.selectionTagDialog, this.tagCollection.length)

      if (!this.selectionTagDialog && this.tagCollection.length < 50) {
        this.selectionTagDialog = true
      }
      if (this.tagCollection.length) {
        if (this.tagCollection.length < 50) {
          const arr = await this.getTagList(this.tagCollection)
          const result = this.transferData(arr, true)
          console.log(result)
          this.handleClickTagData = result.data
          this.handleClickTagDataHeader = result.header
        } else {
          this.$confirm(
            `你当前选择了${this.tagCollection.length}个构件,数据导出需要等待一段时间,是否继续`,
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            }
          ).then(() => {
            this.selectionTagDialog = true
            this.modelTreeLoading = true
            const length = Math.ceil(this.tagCollection.length / 20)
            const resultArr = _.chunk(this.tagCollection, 20)
            const result = {
              data: [],
              header: [],
            }
            let count = 0
            _.times(length, async (i) => {
              const arr = await this.getTagList(resultArr[i])
              const data = this.transferData(arr, true)
              result.data.push(...data.data)
              result.header = data.header
              count = count + 1
              if (count === length) {
                this.handleClickTagData = result.data
                this.handleClickTagDataHeader = result.header
                this.modelTreeLoading = false
                console.log('handleClickTagData', this.handleClickTagData)
                console.log('handleClickTagDataHeader', this.handleClickTagDataHeader)
              }
            })
          })
        }
      } else {
        this.handleClickTagData = []
        this.handleClickTagDataHeader = []
      }
    },
    // 下载相关
    async downloadRelated(data) {
      console.log(data)
      const config = { responseType: 'arraybuffer' }
      const instance = axios.create(config)
      const res = await instance.get(
        `${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5}`
      )
      console.log('created res', res.headers['content-type'])
      this.downLoadBlob({
        name: data.fileName,
        type: res.headers['content-type'],
        data: res.data,
      })
    },
    // 点击文件名浏览
    showRelated(data) {
      window.open(`${currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.md5}`)
    },
    // 批量选中项
    selectionChange(ret) {
      console.log(ret)
      this.relatedFilesSelectedId = _.map(ret, (item) => {
        // return item.id
        return item.objectAssacId
      })
      console.log(this.relatedFilesSelectedId)
    },
    // 批量删除相关
    batchDeleteRelated() {
      if (this.relatedFilesSelectedId && this.relatedFilesSelectedId.length > 0) {
        this.$confirm('此操作将进行批量删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.operateDeleteMethod(this.relatedFilesSelectedId)
        })
      } else {
        this.$alert('请勾选需要删除的项', '提示', {
          confirmButtonText: '确定',
          callback: () => {},
        })
      }
    },
    // 点击上传按钮
    uploadBtn() {
      this.uploadRelatedVisible = true
      if (this.tabName === 'taskPhotos' || this.tabName === 'planPhotos') {
        this.accept = '.png, .jpg, .jpeg, .JPG, .JPEG, .PNG'
      } else {
        this.accept = '.doc, .docx, .pdf, .xlxs'
      }
    },
    // 点击tab
    async handleRelatedTask(tab) {
      this.tabName = tab.name
      this.relatedFilesSelectedId = []
      if (this.taskTotalData) {
        switch (this.tabName) {
          case 'taskPhotos':
            this.taskRelatedList = this.taskTotalData.imageList
            break
          case 'taskFiles':
            this.taskRelatedList = this.taskTotalData.documentFileList
            break
          default:
        }
      }
      if (this.planTotalData) {
        switch (this.tabName) {
          case 'planPhotos':
            this.planRelatedList = this.planTotalData.imageList
            break
          case 'planFiles':
            this.planRelatedList = this.planTotalData.documentFileList
            break
          default:
        }
      }
    },
    handleCheck() {
      if (this.handleCheckLoadingTimer) {
        clearInterval(this.handleCheckLoadingTimer)
      }
      this.playing = false
      clearInterval(this.timer)
      this.handleCheckLoadingTimer = setInterval(() => {
        const dayList = _.map(this.model, (item) => {
          return moment(item.currentDate).format('YYYY-MM-DD')
        })
        const diff = moment(this.filter.checkDate).diff(moment(this.filter.dateRange[0]), 'day')
        const checkDateIndex = _.indexOf(
          dayList,
          moment(this.filter.checkDate).format('YYYY-MM-DD')
        )
        const isCorrect = checkDateIndex !== -1 && checkDateIndex === diff
        if (isCorrect) {
          clearInterval(this.handleCheckLoadingTimer)
          this.sliderLoading = false
          const distanceTime = dayList.indexOf(moment(this.filter.checkDate).format('YYYY-MM-DD'))
          const toTodayData = _.slice(this.modelList, 0, this.currentTiming)
          setTimeout(() => {
            this.currentTiming = distanceTime
            this.slider1 = this.currentTiming
            this.currentModel = this.model[this.currentTiming]
            this.$emit('changeModelColor', {
              data: toTodayData,
              day: this.currentTiming,
            })
          }, 1000)
        } else {
          this.sliderLoading = true
        }
      }, 200)
    },
    initModel() {
      if (
        this.progressId &&
        this.filter.dateRange[0] &&
        this.filter.dateRange[1] &&
        moment(this.filter.dateRange[0]).isBefore(this.filter.dateRange[1])
      ) {
        const currentPlan = _.find(this.planModelInfo, ['id', JSON.parse(this.progressId).id])
        console.log(this.sliderMaxLenngth)
        if (_.isNil(currentPlan)) {
          const momentStart = this.filter.dateRange[0] ? moment(this.filter.dateRange[0]) : moment()
          const momentFinish = this.filter.dateRange[1]
            ? moment(this.filter.dateRange[1])
            : moment()
          const diff = momentFinish.diff(momentStart, 'days')
          const diffArray = [...Array(diff).keys()]
          this.arrPoints = []
          const datePoint = _.filter(diffArray, (i) => {
            return _.isInteger(i / 30)
          })
          if (_.last(datePoint) !== _.last(diffArray)) {
            datePoint.push(_.last(diffArray))
          }
          this.arrPoints = datePoint
          _.times(datePoint.length > 1 ? datePoint.length - 1 : 1, async (index) => {
            const process = _.find(this.processModelList, (o) => {
              return o.md5 === JSON.parse(this.selectionModel).md5
            })
            const params = {
              processId: process.id,
              activityId: JSON.parse(this.progressId).id,
              startTime: (datePoint.length > 1
                ? moment(this.filter.dateRange[0]).add(datePoint[index], 'days')
                : moment(this.filter.dateRange[0])
              ).format('YYYY-MM-DD'),
              finishDate: (datePoint.length > 1
                ? moment(this.filter.dateRange[0]).add(datePoint[index + 1] - 1, 'days')
                : moment(this.filter.dateRange[1])
              ).format('YYYY-MM-DD'),
            }

            params.actualStartDate =
              this.showVersion === '2' ? moment(this.filter.dateRange[0]).format('YYYY-MM-DD') : ' '
            params.actualEndDate =
              this.showVersion === '2' ? moment(this.filter.dateRange[1]).format('YYYY-MM-DD') : ' '
            if (
              index === datePoint.length - 2 &&
              moment(this.filter.dateRange[1]).diff(
                moment(this.filter.dateRange[0]).add(datePoint[index + 1] - 1, 'days'),
                'days'
              ) > 0
            ) {
              params.finishDate = moment(this.filter.dateRange[1]).format('YYYY-MM-DD')
            }
            const res = await planDetail.getActivityModel(params)

            if (res && res.data && res.success) {
              if (
                res.data.oldData &&
                res.data.newData &&
                res.data.activityId === JSON.parse(this.progressId).id
              ) {
                this.allModelRes = [...this.allModel, ...res.data.oldData]
                // 依据时间去重
                this.allModelRes = _.uniqBy([...this.allModel, ...res.data.oldData], 'currentDate')
                // 依据时间排序
                this.allModel = _.orderBy(this.allModelRes, ['currentDate'], ['asc'])
                // 筛选只含有List的数据
                this.allModelList = _.map(this.allModel, (el) => {
                  // 选择所有key是List结尾的对象
                  el = _.pickBy(el, (v, k) => {
                    return _.endsWith(k, 'List')
                  })
                  // 将key的'List'去掉
                  return _.mapKeys(el, (v, k) => {
                    return k.replace('List', '')
                  })
                })
                res.data.newData.forEach((item) => {
                  this.allShowNum.push(item)
                })
                this.model = this.allModel
                this.modelList = this.allModelList
                this.showNum = this.allShowNum
                if (
                  !_.isEmpty(this.model) &&
                  moment(this.model[0].currentDate).format('YYYY-MM-DD') ===
                    moment(this.filter.dateRange[0]).format('YYYY-MM-DD') &&
                  _.isNil(this.handleCheckLoadingTimer) &&
                  _.isNil(this.sliderLoadingTimer)
                ) {
                  this.sliderLoading = false
                }
                if (this.allModel.length >= this.sliderMaxLenngth) {
                  this.planModelInfo.push({
                    id: JSON.parse(this.progressId).id,
                    modelRes: this.allModelRes,
                    model: this.allModel,
                    modelList: this.allModelList,
                    showNum: this.allShowNum,
                  })
                }
                console.log(this.planModelInfo)
              }
            }
          })
        } else {
          this.sliderLoading = false
          // 总的计划开始时间与结束时间间隔天数
          const planDays = moment(this.planFinishDate).diff(moment(this.planStartDate), 'day') + 1
          console.log(planDays)
          // 实际选择的开始时间与总计划开始时间间隔天数
          const sliceStart = moment(this.filter.dateRange[0]).diff(this.planStartDate, 'day')
          // 实际选择的结束时间与总计划结束时间间隔天数
          const sliceEnd =
            planDays - moment(this.planFinishDate).diff(this.filter.dateRange[1], 'day')
          console.log(sliceStart, sliceEnd)
          // sliceStart~sliceEnd即实际选择的时间范围内的数据
          this.model = _.slice(currentPlan.model, sliceStart, sliceEnd)
          this.modelList = _.slice(currentPlan.modelList, sliceStart, sliceEnd)
          this.showNum = currentPlan.modelList
          console.log(this.model)
        }
      }
    },
    minusSpeed() {
      this.currentSpeed = this.currentSpeed - 1
      if (this.currentSpeed < 0) {
        this.currentSpeed = 0
      }
      console.log(this.speedModes[this.currentSpeed])
    },
    addSpeed() {
      this.currentSpeed = this.currentSpeed + 1
      if (this.currentSpeed > 2) {
        this.currentSpeed = 2
      }
      console.log(this.speedModes[this.currentSpeed])
    },
    sliderChanged(val) {
      if (this.sliderLoadingTimer) {
        clearInterval(this.sliderLoadingTimer)
      }
      console.log('sliderChanged', val)
      this.playing = false
      this.slider1 = val
      clearInterval(this.timer)
      const currentDay = moment(this.filter.dateRange[0])
        .add(val - 1, 'day')
        .format('YYYY-MM-DD')
      this.sliderLoadingTimer = setInterval(() => {
        if (_.isEmpty(this.model)) {
          this.sliderLoading = true
          return
        }
        const dateTimeList = _.map(this.model, (item) => {
          return moment(item.currentDate).format('YYYY-MM-DD')
        })
        const dayIndex = _.indexOf(dateTimeList, currentDay)
        const isCorrect = dayIndex !== -1 && dayIndex === val - 1
        if (isCorrect) {
          this.sliderLoading = false
          this.currentTiming = val
          this.currentModel = this.model[val - 1]
          clearInterval(this.sliderLoadingTimer)
        } else {
          this.sliderLoading = true
        }
      }, 200)
    },
    // 隐藏或打开面板
    showProcessMode() {
      this.$emit('isShowMode')
    },
    reset() {
      this.slider1 = 0
      this.currentTiming = 0
      this.playing = false
      this.currentModel = _.isEmpty(this.model) ? null : this.model[0]
      this.$emit('resetProgress')
      clearInterval(this.timer)
      if (this.sliderLoadingTimer) {
        clearInterval(this.sliderLoadingTimer)
        this.sliderLoadingTimer = null
      }
      if (this.handleCheckLoadingTimer) {
        clearInterval(this.handleCheckLoadingTimer)
        this.handleCheckLoadingTimer = null
      }
    },
    btnPlay() {
      if (!this.playing) {
        if (!this.loaded) {
          this.btnPlayLoading = true
          return
        }
        if (this.sliderLoading) {
          return
        }
        this.btnPlayLoading = false
        this.playing = true
        const toTodayData = _.slice(this.modelList, 0, this.currentTiming)

        // const { CancelToken } = axios
        if (this.currentTiming + this.speedModes[this.currentSpeed] <= this.model.length + 1) {
          this.timer = setInterval(() => {
            this.currentTiming = this.currentTiming + this.speedModes[this.currentSpeed]
            this.slider1 = this.currentTiming
            this.currentModel = this.model[this.currentTiming - 1]
          }, 1000)
        } else {
          this.currentModel = _.last(this.model)
          this.currentTiming = this.model.length
          this.slider1 = this.model.length
        }
      } else {
        this.playing = false
        clearInterval(this.timer)
      }
    },
    // 点击任务
    async handleClickTask(item) {
      this.$store.dispatch('planItemClicked', item)
      this.showTaskDetail = true
      this.taskItem = item
      this.taskRelatedLoading = true
      this.playing = false

      clearInterval(this.timer)
      const res = await this.apiRelatedFiles({
        method: 'relatedList',
        params: {
          where: {
            activityId: item.id,
            fileType: ['ImageConn', 'DocumentConn'],
          },
        },
      })
      if (res.success && res.data) {
        this.taskTotalData = res.data
        switch (this.tabName) {
          case 'taskPhotos':
            this.taskRelatedList = this.taskTotalData.imageList
            break
          case 'taskFiles':
            this.taskRelatedList = this.taskTotalData.documentFileList
            break
          default:
        }
      }
      this.taskRelatedLoading = false

      console.log(res)
    },
    async handleFilter() {
      this.modelRes = []
      this.model = []
      if (
        this.selectionModel &&
        this.progressId &&
        this.filter.dateRange[0] &&
        this.filter.dateRange[1] &&
        moment(this.filter.dateRange[0]).isBefore(this.filter.dateRange[1])
      ) {
        this.reset()
        this.plans = await this.init()
        this.initModel()
        this.basePlans = _.cloneDeep(this.plans)
      } else {
        this.$message({
          message: '请确认选择的数据是否有效！',
          type: 'warning',
        })
      }
    },
    async init() {
      this.loading = true
      const query = {
        activityId: JSON.parse(this.progressId).id,
        startDate:
          this.filter.dateRange && this.filter.dateRange[0]
            ? moment(this.filter.dateRange[0]).format('YYYY-MM-DD')
            : '',
        endDate:
          this.filter.dateRange && this.filter.dateRange[1]
            ? moment(this.filter.dateRange[1]).format('YYYY-MM-DD')
            : '',
        buildStatusList: this.filter.buildStatus ? this.filter.buildStatus : [0],
      }
      const plans = await planDetail.initList(query)
      this.loading = false
      console.log('aaaaaaaaaaaaaaaaaaa')
      if (plans && plans.code === 0) {
        this.planLoading = false
        const list = _.cloneDeep(plans.data)
        const levelMin = _.min(
          _.map(plans.data, (i) => {
            return i.activityLevel
          })
        )
        const idArr = []
        _.forEach(list, (i) => {
          i.editing = false
          const parent = _.find(list, { id: i.parentActivityId })
          if (parent) {
            if (!parent.children) {
              parent.children = []
            }
            parent.children.push(i)
            idArr.push(i.id)
          }
        })
        const res = list.filter((item) => {
          return !idArr.includes(item.id)
        })
        console.log('project数据', res)
        return res
      }
      return []
    },
    async dateRangeChanged() {
      // this.loading = false
    },
    // 下拉框改变
    async searchProcessPlan() {
      //  拿到现有SiteId下所有的计划列表（和搜索是一个方法）
      const query = {
        SiteId: this.currentProject.id,
        ActivityTypeStr: '0,1',
        Name: '',
      }
      // 河源区分计划
      if (currentEnv.VUE_APP_CURRENT_PROJECT === 'HY') {
        query.Code = 'Plan'
      }
      const res = await constructionManage.askPlanList(query)
      const arr = res.data.slice(0, 10)
      console.log(arr)
      this.allPlanArr = arr
    },
    // 关闭进度模拟模式
    changeProcessMode() {
      this.$emit('changeProcessMode', false)
    },
    // 选择模型
    changeProcessModel(val) {
      // 重新加载模型
      this.$emit('changePlayerId', JSON.parse(val))
      this.reset()
    },
    // 获取模型列表
    async getProcessModel() {
      this.processModelList = []
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          pageNo: 1,
          pageSize: 1000000,
          parametercode: 'docClass3DModelClass',
          sort: 'seqNo:asc',
          siteId: this.currentProject.id,
          // code: data.cableCode,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        this.processModelList = res.data
      }
    },
  },
  destroyed() {
    console.log('destroyed')
    this.$emit('recoverModel')
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>

.process-select {
  height: calc(30% - 5px);
  overflow-y: scroll;
}
.today-task {
  cursor: pointer;
}
.work-status {
  // background-color: #40333363;
  margin: 10px;
  padding: 10px;
}
.h-40 {
  height: 40%;
}
.h-60 {
  height: 60%;
}
.h-90 {
  height: 90%;
}
/deep/ .el-loading-parent--relative {
  top: 0 !important;
  left: 0 !important;
}
.model_data {
  left: 30px;
  top: 60px;
  z-index: 999;
  // background-color: RGB(5, 33, 54) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  .task-item {
    margin-left: 10px;
    color: #4088cc;
    cursor: pointer;
  }
}
.info-panel {
  margin-top: 10px;
  .close-task {
    cursor: pointer;
    float: right;
  }
  .panel-detail {
    height: 160px;
    width: 80%;
    margin-bottom: 10px;
    background-color: #0c2134;

    .detail-title {
      margin: 20px 0 10px 10px;
      // color: #fff;
      font-size: 20px;
    }

    .today-taks {
      margin: 10px;
      // color: #fff;
    }
  }
}
.title {
  font-size: 12px;
}
.select-model {
  margin-left: 50px;
}
.control-icon {
  cursor: pointer;
  margin: 5px;
  font-size: 14px;
}
.search-item {
  margin: 10px;
}
.process-info {
  height: 90%;
  overflow-y: scroll;
  .process-info__list {
    border: 1px solid #dcdfe6;
    .info-left {
      display: inline-block;
      padding: 8px 20px;
      font-size: 12px;
      background-color: #f2f2f2;
      border-right: 1px solid #dcdfe6;
      width: 30%;
    }
    span {
      cursor: pointer;
      color: #409eff;
    }
  }
  .b-none {
    border-bottom: none;
  }
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
/deep/.el-card__body {
  height: 100%;
}
/deep/.el-tabs__content {
  height: 80% !important;
}
.today-task-h3 {
  font-weight: 600;
}
.today-task-box {
  height: calc(100% - 60px);
  overflow-y: auto;
}

</style>
